export const getManualPartCountManagement = (state) => {
  return state.manualPartCountManagement;
};
